import React from 'react';
import { ScrollView, View } from 'react-native';
import Text from '@/components/Typography/Text';
import AutoTopUpSettings from '@/components/Settings/AutoTopUpSettings';
export default function AutoTopupSetupComplete() {
  return <ScrollView contentContainerStyle={{ padding: 24, alignItems: 'center' }}>
    <View style={{ width: '100%', maxWidth: 620, gap: 12 }}>
      <Text size="xl" weight="semibold">Finish auto top-up setup</Text>
      <Text size="s" color="secondary">Saving a payment method does not authorize automatic purchases. Review your settings below. If your saved method has not appeared yet, reload the settings after Whop confirms it.</Text>
      <AutoTopUpSettings startEditing />
    </View>
  </ScrollView>;
}
